import { createFileRoute } from '@tanstack/react-router';

import { WgComposeBriefDtoSectionCategory } from 'src/apis/backend/generated/models';

import { SectionRequestView } from 'src/sections/white-glove/section/section-request-view';

/**
 * Asking us to build the brand's footer.
 *
 * A path of its own rather than a mode of the calendar. A footer is not dated
 * work: nothing sends on the date and nothing goes live on it, the piece lands
 * in the brand's library and every email built afterwards carries it. It is
 * reached from the sections library, which is where the footer it replaces
 * lives. The header has the same page at `white-glove/header`.
 */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove/footer')({
  component: WgFooterPage,
});

function WgFooterPage() {
  return <SectionRequestView category={WgComposeBriefDtoSectionCategory.footer} />;
}
